export * from './ScanToPayFooter';
